module.exports = __webpack_public_path__ + "static/media/dall_e_3_ai.5ed33728.png";